import { Overrides } from '@material-ui/core/styles/overrides'

import { greyPalette, llamayaLink } from './colors'

export const masmovilIconButtonOverride: Overrides = {
  MuiIconButton: {
    root: {
      color: greyPalette[900],
      borderColor: greyPalette[900],
    },
  },
}

export const llamayaIconButtonOverride: Overrides = {
  MuiIconButton: {
    root: {
      color: llamayaLink.main,
      borderColor: llamayaLink.main,
    },
  },
}
